// extracted by mini-css-extract-plugin
export default {"link":"styles_link__Ji93w","buttonsHolder":"styles_buttonsHolder__IjJrN"};